import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { switchMap } from "rxjs/operators";
import { combineLatest } from "rxjs";
import { SubSink } from "subsink";

import { Submenu, Configuration } from "@/shared-module/models";
import { ZoneItem } from "@/shared-module/components";
import { ConfigurationService, PageService } from "@/shared-module/services";

@Component({ templateUrl: "company.component.html" })
export class CompanyComponent implements OnInit, OnDestroy {
  title: string;
  subtitle: string;
  zones: ZoneItem[] = [];
  subMenu: Submenu;
  configuration: Configuration;
  nextDecision: Date;
  path: string;
  subpath: string;
  token: string;
  subs = new SubSink();

  constructor(
    private route: ActivatedRoute,
    private pageService: PageService,
    private configurationService: ConfigurationService,
  ) {}

  ngOnInit() {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => (thisObject.configuration = c),
    );

    const combine = combineLatest(
      this.route.params,
      this.route.queryParams,
    ).pipe(switchMap((results) => this.getObservable()));
    this.subs.sink = combine.subscribe((s: any) => this.loadPageContent(s));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  loadPageContent(s: any) {
    this.subMenu = s.subMenu;
    this.title = s.title;
    this.subtitle = s.subTitle;
    this.nextDecision = s.nextDecision;
    this.token = s.userPilotToken;
    this.load(s.zones);
  }

  getObservable() {
    let path: string;
    let subpath: string;
    if (this.route.snapshot.paramMap.has("path")) {
      path = this.route.snapshot.paramMap.get("path");
    }
    if (this.route.snapshot.paramMap.has("subpath")) {
      subpath = this.route.snapshot.paramMap.get("subpath");
    }
    const regionParam = this.route.snapshot.queryParams;
    return this.pageService.getpath("company", path, subpath, regionParam);
  }

  load(zones: any[]) {
    this.zones = [];

    if (zones) {
      zones.forEach((zoneitm) => {
        this.zones.push(
          new ZoneItem(
            zoneitm.zoneType,
            zoneitm.title,
            zoneitm.dataSource,
            zoneitm.error,
            zoneitm.width,
            false,
          ),
        );
      });
    }
  }
}
